import { SYSConfig, SYSState, html, render } from "../../../../_ovlclient/src"
import { HandleOvlFocusIn } from "../../../../_ovlclient/ovlsyscomponents/sysdefaulthtmlsnippets01"
export let startRender = async (state: SYSState) => {
  console.log(
    `itflies newservice ${SYSConfig._system.versionInfo.frontend.app.version} is initialised and is starting...`
  )
  await render(
    html`
      <div class="fd-page" @focusin=${(e) => HandleOvlFocusIn(e)}>
        <div id="SYSScreens">
          <ovl-screencontainer> </ovl-screencontainer>
        </div>
        <div id="SYSDialogs">
          <ovl-dialogcontainer> </ovl-dialogcontainer>
          <ovl-snack> </ovl-snack>
        </div>
      </div>
    `,
    document.getElementById("app")
  )
}
